/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit promo" |
*
* @param {Promo_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_edit_title = /** @type {((inputs?: Promo_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Edit_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica promo")
	return /** @type {LocalizedString} */ ("Edit promo")
});